<template>
  <div class="login_page">
    <img
      class="goback"
      :class="[$store.state.isMirroring && 'mirror']"
      src="@/assets/back_new.png"
      alt=""
      :style="{ top: `calc(0.2rem + ${$store.state.statusBarHeight}px)` }"
      @click="goback"
    />
    <div
      v-if="registerType == 'PHONE' && showForgotPassword"
      class="forget_box"
      :class="[$store.state.isMirroring && 'mirror']"
      :style="{ marginTop: 0, top: `calc(0.2rem + ${$store.state.statusBarHeight}px)` }"
      @click="openForgetPasswordPopup"
    >
      {{ $t('loginAndRegister.forgotPassword') }}
      <img class="unfold_icon" src="@/assets/unfold_icon.png" alt="" />
    </div>
    <img class="top_bg" src="@/assets/top_bg.png" alt="" />
    <img class="bottom_bg" src="@/assets/bottom_bg_right.png" alt="" />
    <div id="title" class="title">
      <div>
        <img v-show="registerType == 'PHONE'" class="title_icon" src="@/assets/phone_text.png" alt="" />
        <img v-show="registerType == 'EMAIL'" class="title_icon" src="@/assets/email_text.png" alt="" />
      </div>
      <div class="sub_title">
        <div v-show="registerType == 'PHONE' && toWhatsapp" class="to_whatsapp_text">
          {{ $t('redesign.sendToWhatsapp') }}
        </div>
        <div class="account">
          <span v-show="registerType == 'PHONE'">+{{ areaCode }}</span>
          <span>{{ account }}</span>
        </div>
      </div>
    </div>
    <div class="login_box">
      <!-- 密码登录 -->
      <div v-if="loginType === 'password'" class="input_area">
        <CommonInput
          v-model="password"
          :placeholder="$t('loginAndRegister.pwd')"
          :type="showPassword ? 'text' : 'password'"
          show-clear
          auto-focus
          :on-focus="onFocus"
          :on-blur="onBlur"
        >
          <img
            v-show="!showPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
          <img
            v-show="showPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
        </CommonInput>
      </div>
      <!-- 验证码登录 -->
      <div v-show="loginType === 'smsCode'" class="input_area">
        <!-- 手机号发送验证码需要滑块验证 -->
        <div v-show="showSlideVerification" id="slideVerification" class="slide_verification"></div>
        <div v-if="!showSlideVerification" class="input_area">
          <CommonInput
            v-model="smsCode"
            type="tel"
            inputmode="numeric"
            :placeholder="registerType == 'PHONE' ? $t('common.smsCode') : $t('common.emailCode')"
            :max-length="VALID_CODE_LENGTH"
            auto-focus
            :on-focus="onFocus"
            :on-blur="onBlur"
          >
            <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="resend">
              {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : count + 's' }}
            </div>
          </CommonInput>
        </div>
      </div>
      <CommonBtn
        v-show="!showSlideVerification"
        class="next_btn"
        :text="$t('common.next')"
        :disabled="disableNext"
        :on-click="tryLogin"
      ></CommonBtn>
      <!-- 切换短信/邮箱验证码验证登录 -->
      <div class="login_type_switch_area">
        <div @click="switchLoginType">
          <span v-if="loginType === 'smsCode'">
            {{ $t('loginAndRegister.pwdLogin') }}
          </span>
          <span v-else-if="loginType === 'password'">
            {{ registerType == 'EMAIL' ? $t('loginAndRegister.emailCodeLogin') : $t('loginAndRegister.smsLogin') }}
          </span>
        </div>
      </div>
    </div>
    <!-- 账号风险提示 -->
    <LoginSecurityDialog
      v-model="showLoginSecurityDialog"
      :email-btn-show="emailBtnShow"
      :phone-btn-show="phoneBtnShow"
      @toVerify="toVerify"
    />
    <!-- 二次验证浮层 -->
    <LoginVerifyPopup
      v-model="showLoginVerifyPopup"
      :email-btn-show="emailBtnShow"
      :phone-btn-show="phoneBtnShow"
      :type="verifyType"
      :email="verifyEmail"
      :phone="verifyPHONE"
      :area-code="areaCode"
      @tryLogin="tryLogin"
    />
    <!-- 忘记密码浮层 -->
    <ForgetPasswordPopup v-if="showForgotPassword" v-model="showForgetPasswordPopup" :phone="areaCode + '' + account" />
    <CommonDialog
      v-model="showPasswordLimitDialog"
      :title="$t('common.attention')"
      :content="$t('loginAndRegister.pwdWrongLimitOverDialog')"
      :confirm-text="$t('common.confirm')"
      :cancel-text="$t('common.cancel')"
      @confirm="switchToVerify"
      @cancel="showPasswordLimitDialog = false"
    />
  </div>
</template>

<script>
import md5 from 'js-md5'
import { Toast } from 'vant'
import CommonInput from '@/components/CommonInput.vue'
import CommonBtn from '@/components/CommonBtn.vue'
import CommonDialog from '@/components/CommonDialog.vue'
import LoginSecurityDialog from '@/components/Login/LoginSecurityDialog.vue'
import LoginVerifyPopup from '@/components/Login/LoginVerifyPopup.vue'
import ForgetPasswordPopup from '@/components/Login/ForgetPasswordPopup.vue'
import throttle from 'lodash/throttle'
import { getBrowserInfo } from '@/utils'
import { postReportLog } from '@/utils/log'
import { VALID_CODE_LENGTH } from '@/utils/constants'

export default {
  name: 'Login',
  components: {
    CommonInput,
    CommonBtn,
    CommonDialog,
    LoginSecurityDialog,
    LoginVerifyPopup,
    ForgetPasswordPopup
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      loginType: this.loginType || 'password',
      phone: '',
      password: '',
      smsCode: '',
      count: 59,
      msgValidating: false,
      account: '',
      areaCode: '',
      registerType: '',
      currentType: '',
      popBtn: '',
      emailBtnShow: false,
      phoneBtnShow: false,
      verifyAccount: '',
      verifyEmail: '',
      verifyPHONE: '',
      paramsData: {},
      verifyType: '',
      showPassword: false,
      showForgotPassword: false,
      showForgetPasswordPopup: false,
      showSlideVerification: false,
      showLoginSecurityDialog: false,
      showLoginVerifyPopup: false,
      firstSendMsg: true,
      showPasswordLimitDialog: false,
      toWhatsapp: false
    }
  },
  computed: {
    disableNext() {
      return false
    }
  },
  watch: {
    phone(e) {
      this.phone = e.replace(/\D/g, '')
    },
    smsCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.tryLogin()
      }
    }
  },
  mounted() {
    this.paramsData = localStorage.getItem('paramsData')
      ? JSON.parse(localStorage.getItem('paramsData'))
      : this.$route.params
    this.account = this.paramsData.account
    this.areaCode = this.paramsData.areaCode
    this.registerType = this.paramsData.registerType
    this.currentType = this.paramsData.registerType
    if (!this.registerType || !this.account) {
      this.goback()
    }
    if (this.registerType === 'PHONE') {
      this.$http
        .post(
          window.serverPath +
            '/api/auth/showForgetPassword?phone=' +
            this.areaCode +
            this.account +
            '&apptype=' +
            localStorage.getItem('apptype')
        )
        .then((res) => {
          if (res.data.code === '200') {
            this.showForgotPassword = !!res.data.data
          }
        })
    }
    this.initSlideVerification()
    postReportLog({
      log_id: '440',
      extra: {
        page: 'login',
        login_type: this.registerType || this.loginType
      }
    })
  },
  methods: {
    onFocus() {
      this.updatePageStyle('focus')
    },
    onBlur() {
      this.updatePageStyle('blur')
    },
    updatePageStyle(event) {
      const title = document.getElementById('title')
      if (title) {
        title.style.marginTop = event === 'focus' ? '0.82rem' : '1.42rem'
      }
    },
    openForgetPasswordPopup() {
      this.showForgetPasswordPopup = true
    },
    goback() {
      this.$router.back()
    },
    resend() {
      if (this.msgValidating) {
        return
      }
      if (this.currentType === 'EMAIL') {
        this.sendSmsCode()
      } else {
        this.showSlideVerification = true
      }
    },
    toVerify(type) {
      this.verifyType = type
      this.verifyAccount = type === 'EMAIL' ? this.verifyEmail : this.verifyPHONE
      this.currentType = type
      this.loginType = 'smsCode'
      this.showLoginVerifyPopup = true
    },
    // 脱敏邮箱
    maskEmail(email) {
      var pattern = /^(.{3})(.*)(@.*)$/
      var match = email.match(pattern)

      if (match) {
        var username = match[1]
        var middleChars = match[2]
        var domain = match[3]

        var maskedMiddleChars = '*'.repeat(middleChars.length)

        var maskedEmail = username + maskedMiddleChars + domain
        return maskedEmail
      } else {
        return email
      }
    },
    // 脱敏手机号
    maskPhoneNumber(phoneNumber) {
      var pattern = /^(.{2})(.*)(.{2})$/
      var match = phoneNumber.match(pattern)

      if (match) {
        var firstTwoDigits = match[1]
        var middleDigits = match[2]
        var lastTwoDigits = match[3]

        var maskedMiddleDigits = '*'.repeat(middleDigits.length)

        var maskedPhoneNumber = firstTwoDigits + maskedMiddleDigits + lastTwoDigits
        return maskedPhoneNumber
      } else {
        return phoneNumber
      }
    },
    switchLoginType() {
      if (this.loginType === 'password') {
        this.loginType = 'smsCode'
        if (this.registerType === 'PHONE') {
          this.showSlideVerification = true
        } else {
          this.showSlideVerification = false
          this.sendSmsCode()
        }
      } else {
        this.loginType = 'password'
        this.showSlideVerification = false
      }
    },
    tryLogin: throttle(
      function (smsCode = '', loginType = '') {
        // 手机登录无区号异常处理
        if (this.registerType === 'PHONE' && !this.areaCode && !this.showLoginVerifyPopup) {
          Toast(this.$t('loginAndRegister.countryUnselectToast'))
          return
        }
        // 无密码或验证码异常处理
        if (!this.password && !this.smsCode && !smsCode) {
          return
        }
        const params = { type: 0 }
        if (this.showLoginVerifyPopup) {
          // 如果是二次验证，loginId传明文的账号
          if (this.registerType === 'EMAIL') {
            params.loginId = this.verifyEmail || this.account
          } else {
            params.loginId = this.verifyPHONE || this.areaCode + '' + this.account
          }
        } else {
          if (this.registerType === 'EMAIL') {
            params.loginId = this.verifyAccount || this.account
          } else {
            params.loginId = this.verifyAccount || this.areaCode + '' + this.account
          }
        }

        // 密码和验证码处理
        if (this.loginType === 'password') {
          params.password = md5(this.password)
        } else if (this.loginType === 'smsCode') {
          params.msgCode = smsCode || this.smsCode // 优先使用传入的验证码
        } else {
          Toast(this.$t('loginAndRegister.unsupportedLoginTypeToast'))
          return
        }

        // 登录方式处理
        params.loginType = loginType || this.currentType // 优先取传入的登录方式
        if (this.showLoginVerifyPopup) {
          // 二次验证
          if (smsCode && smsCode.length === VALID_CODE_LENGTH) {
            this.login(params)
          } else {
            Toast(this.$t('accountSecurity.wrongCodeToast'))
          }
        } else {
          this.login(params)
        }
      },
      5000,
      { trailing: false }
    ),
    login(params) {
      this.$http
        .post(window.serverPath + '/api/auth/newLogin', {
          ...params,
          apptype: localStorage.getItem('apptype'),
          device: getBrowserInfo() // 用户浏览器埋点
        })
        .then((res) => {
          if (res.data.code === '200') {
            // 记住本次登录的方式（PHONE or EMAIL）
            localStorage.setItem('lastLoginType', this.registerType)
            localStorage.removeItem('paramsData')
            sessionStorage.removeItem('acctData')
            localStorage.setItem('token', res.data.data.token)
            sessionStorage.setItem('firstLogin', 0)

            this.getUserInfo(res.data.data.token)
          } else if (res.data.code === '60010') {
            this.showPasswordLimitDialog = true
          } else if (res.data.code === '60012') {
            if (res.data.data && res.data.data.result.EMAIL) {
              this.emailBtnShow = true
              this.verifyEmail = res.data.data.result.EMAIL
            }
            if (res.data.data && res.data.data.result.PHONE) {
              this.phoneBtnShow = true
              this.verifyPHONE = res.data.data.result.PHONE
            }
            this.showLoginSecurityDialog = true
          } else if (res.data.code === '100004' || res.data.code === '100022') {
            Toast({
              message: res.data.message
            })
          } else {
            Toast({
              message: this.$t('loginAndRegister.loginFailedToast')
            })
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    },
    switchToVerify() {
      this.showPasswordLimitDialog = false
      this.loginType = 'smsCode'
      this.showSlideVerification = true
    },
    getUserInfo() {
      const $this = this
      this.$http
        .get(window.serverPath + '/api/user/info')
        .then((res) => {
          if (res.data.code === '200') {
            let store = localStorage.getItem('store') || '{}'
            $this.$store.replaceState(
              Object.assign({}, this.$store.state, {
                ...JSON.parse(store),
                userInfo: res.data.data
              })
            )
            localStorage.setItem('store', JSON.stringify(this.$store.state))
            // sessionStorage中存储了重定向信息则重定向
            const redirectInfo = sessionStorage.getItem('redirectInfo')
            if (redirectInfo) {
              $this.$router.replace(redirectInfo)
              sessionStorage.removeItem('redirectInfo')
            } else {
              $this.$router.replace({
                name: 'Home'
              })
            }
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    },
    sendSmsCode(rid = '') {
      if (this.msgValidating) {
        return
      }
      let isEmail = this.currentType === 'EMAIL'
      const $this = this
      const phone = this.areaCode + '' + this.account
      const email = this.account
      const url = window.serverPath + (isEmail ? '/api/auth/getNewEmailCode/LOGIN' : '/api/auth/getNewSmsCode/LOGIN')
      let params = {
        email: '',
        phone: '',
        areaCode: this.areaCode,
        rid: rid
      }
      if (isEmail) {
        params.email = email
      } else {
        params.phone = phone
      }
      if (phone || email) {
        this.$http
          .post(url, params)
          .then((res) => {
            if (res.data.code === '200') {
              $this.msgValidating = true
              $this.firstSendMsg = false
              $this.toWhatsapp = res.data.data === 'WhatsApp'
              const interval = window.setInterval(() => {
                $this.count -= 1
                if ($this.count <= 0) {
                  clearInterval(interval)
                  $this.msgValidating = false
                  $this.count = 59
                }
              }, 1000)
            } else if (res.data.code === '40001') {
              Toast({
                message: this.$t('loginAndRegister.userNotExistToast')
              })
            } else {
              Toast({
                message: res.data.message
              })
            }
          })
          .catch(() => {
            console.log('异常')
            $this.msgValidating = false
            $this.count = 59
          })
      } else {
        Toast({ message: this.$t('loginAndRegister.phoneIncorrectToast') })
      }
    },
    isMasked(str) {
      return str.indexOf('*') !== -1
    },
    initSlideVerification() {
      const $this = this
      initSMCaptcha(
        {
          organization: '90I5YRBCdvRoD8mXmETq',
          domains: ['captcha-xjp.fengkongcloud.cn'], // 新加坡
          product: 'embed', // 展现形式
          appendTo: 'slideVerification', // 指定 DOM 节点
          mode: 'slide', // 验证码模式
          lang: 'en',
          width: 295,
          style: {
            slideBar: {
              color: '#3FBB70',
              successColor: '#3FBB70',
              border: 'none',
              process: {
                background: '#3FBB7033',
                failBackground: '#ff4c6233'
              },
              button: {
                boxShadow: 'none',
                background: '#3FBB70',
                failBackground: '#ff4c62'
              }
            }
          }
        },
        (SMCaptcha) => {
          SMCaptcha.onSuccess(function (data) {
            if (data.pass) {
              $this.showSlideVerification = false
              SMCaptcha.reset()
              $this.sendSmsCode(data.rid)
            }
          })
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_page {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #d9ffe8 0.35%, rgba(255, 255, 255, 0) 52.27%), #f5fff9;
  position: relative;
  padding: 0 0.24rem;
  box-sizing: border-box;
  overflow: hidden;
}

.goback {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  left: 0.18rem;
  z-index: 2;
}

.goback.mirror {
  left: auto;
  right: 0.18rem;
  transform: rotate(180deg);
}

.forget_box {
  position: absolute;
  right: 0.2rem;
  display: flex;
  height: 0.3rem;
  padding: 0 0.1rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  z-index: 2;
}

.forget_box.mirror {
  left: 0.2rem;
  right: auto;
}

.unfold_icon {
  width: 0.08rem;
  height: 0.08rem;
  margin-inline-start: 0.03rem;
}

.top_bg {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 1;
}

.bottom_bg {
  position: absolute;
  bottom: 0;
  width: 70%;
  right: 0;
  z-index: 1;
}

.title {
  width: 100%;
  margin: 1.42rem 0 0.24rem;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.title_icon {
  height: 0.36rem;
  display: block;
}

.sub_title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.to_whatsapp_text {
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  color: #3fbb70;
  margin-top: 0.04rem;
  font-weight: 600;
  line-height: 0.22rem;
  flex-shrink: 0;
  margin-inline-end: 0.04rem;
}

.account {
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  color: #3fbb70;
  margin-top: 0.04rem;
  font-weight: 600;
  line-height: 0.22rem;
  display: flex;
  flex-shrink: 0;
  direction: ltr;
}

.login_box {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input_area {
  width: 100%;
}

.next_btn {
  margin-top: 0.52rem;
}

.slide_verification {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.login_type_switch_area {
  font-size: 0.14rem;
  color: #3fbb70;
  margin-top: 0.12rem;
  text-align: center;
  font-weight: 600;
}

.password_status_icon {
  margin-inline-start: 0.2rem;
  width: 0.2rem;
  height: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue